<div class="content content-md">
  <div [ngClass]="scrollContentClass">
    @if (isBusy || searchService.isSearching) {
      <app-overlay imgClass='cg-overlay-img'></app-overlay>
    }
    @if (!searchService.isSearching && !searchResults && assetAvailabilitySummary) {
      <div>
        <div id="content-list" class="list list-md asset-availability-list">
          <button class="item item-block item-md button-shade" text-wrap=""
            (click)="openEquipmentAssetByStatus(null, null)">
            <div class="item-inner" >
              <div class="input-wrapper">
                <div class="list-label label label-md">
                  <h2 class="ellipses-label">{{this.translateService.instant('main.data.all_statuses')}}</h2>
                  <p class="ellipses-sublabel"
                    [innerHTML]="getLabelTranslation('Asset_count', [assetAvailabilitySummary.asset_count | number])">
                  </p>
                </div>
                <app-item-arrow></app-item-arrow>
              </div>
              <div class="button-effect"></div>
            </div>
          </button>
          <div class="pie-container">
            <canvas baseChart style="cursor: pointer;" [datasets]="pieChartDatasets" [type]="'pie'"
              [options]="pieChartOptions" [plugins]="pieChartPlugins" [labels]="pieChartLabels"
              (chartClick)="chartClicked($event)" [legend]="pieChartLegend">
            </canvas>
          </div>
          <div class="availability-container">
            <div style="vertical-align:middle">
              @if (availableAvailability) {
                <button class="item item-block item-md" text-wrap=""
                  (click)="openEquipmentAssetByStatus(availableAvailability.status_type, availableAvailability.status_label)">
                  <div class="item-inner">
                    <div class="input-wrapper">
                      <div class="list-label label label-md">
                        <div class="availability-label"
                          [style.color]="availableAvailability.label_color">
                        {{getLabel(availableAvailability.status_label)}}</div>
                        <div class="availability-sublabel"
                          [style.color]="availableAvailability.label_color">
                        {{availableAvailability.asset_percent}}%</div>
                        <p class="ellipses-sublabel"
                          [innerHTML]="getLabelTranslation('Asset_count', [availableAvailability.asset_count | number])">
                        </p>
                      </div>
                      <app-item-arrow></app-item-arrow>
                    </div>
                    <div class="button-effect"></div>
                  </div>
                </button>
              }
              @if (unavailableAvailability) {
                <button class="item item-block item-md" text-wrap=""
                  (click)="openEquipmentAssetByStatus(unavailableAvailability.status_type, unavailableAvailability.status_label)">
                  <div class="item-inner">
                    <div class="input-wrapper">
                      <div class="list-label label label-md">
                        <div class="availability-label"
                          [style.color]="unavailableAvailability.label_color">
                        {{getLabel(unavailableAvailability.status_label)}}</div>
                        <div class="availability-sublabel"
                          [style.color]="unavailableAvailability.label_color">
                        {{unavailableAvailability.asset_percent}}%</div>
                        <p class="ellipses-sublabel"
                          [innerHTML]="getLabelTranslation('Asset_count', [unavailableAvailability.asset_count | number])">
                        </p>
                      </div>
                      <app-item-arrow></app-item-arrow>
                    </div>
                    <div class="button-effect"></div>
                  </div>
                </button>
              }
              @if (onRentAvailability) {
                <button class="item item-block item-md" text-wrap=""
                  (click)="openEquipmentAssetByStatus(onRentAvailability.status_type, onRentAvailability.status_label)">
                  <div class="item-inner">
                    <div class="input-wrapper">
                      <div class="list-label label label-md">
                        <div class="availability-label" [style.color]="onRentAvailability.label_color">
                        {{getLabel(onRentAvailability.status_label)}}</div>
                        <div class="availability-sublabel"
                          [style.color]="onRentAvailability.label_color">
                        {{onRentAvailability.asset_percent}}%</div>
                        <p class="ellipses-sublabel"
                          [innerHTML]="getLabelTranslation('Asset_count', [onRentAvailability.asset_count | number])">
                        </p>
                      </div>
                      <app-item-arrow></app-item-arrow>
                    </div>
                    <div class="button-effect"></div>
                  </div>
                </button>
              }
            </div>
            @if (showGeographyStats()) {
              <app-geography-stats
                *featureFlag="'flagEnableGeographyStats'"
                [data]="geographyStatsList()"
                (navigate)="onGeoNavigate($event)"
                />
            }
          </div>
        </div>
      </div>
    }
  </div><!-- end of scroll content -->
  @if (searchResults) {
    <app-search-results />
  }
</div>
